import { render } from "./create_rate.vue?vue&type=template&id=2796c042&scoped=true"
import script from "./create_rate.vue?vue&type=script&lang=js"
export * from "./create_rate.vue?vue&type=script&lang=js"

import "./create_rate.vue?vue&type=style&index=0&id=2796c042&scoped=true&lang=css"

import exportComponent from "/Users/hitenradadiya/Front/shiv_mfg_front/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-2796c042"]])

export default __exports__